import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Login from "../../Pages/Login";
import ForgotPassword from "../../Pages/ForgotPassword";

const AuthRoutes = () => {
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/login" />
      </Route>
      <Route exact path="/login" render={(props) => <Login {...props} />} />
      <Route
        exact
        path="/forgot-password"
        render={(props) => <ForgotPassword {...props} />}
      />
      <Redirect from="*" to="/login" />
    </Switch>
  );
};

export default AuthRoutes;
